import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { message } from 'antd'
import { mixPostV1, mixGetV1, mixGetImage, mixVNDtoUSA } from 'services/mixin'
import CheckoutPaymentForm from 'components/Checkout/CheckoutPaymentForm'


import './Checkout.scss'
const Checkout = () => {
  const {slug} = useParams()
  const [detail, setDetail] = useState({})
  const [user, setUser] = useState(null)

  // Function
  const getGoiDetail = async (slug:any) => {
    try {
      const res = await mixGetV1(`/api/v1/fe/package/${slug}`)

      if(res.status) {
        const data = res.data;

        // Parse content nếu là string JSON
        if (typeof data.content === "string") {
          try {
            data.content = JSON.parse(data.content);
          } catch (error) {
            console.error("Lỗi parse JSON content:", error);
          }
        }

        setDetail(data);
      }
    } catch(err) {
      message.error(err?.message || 'Có lỗi xảy ra')
    }
  }
  const getUser = async () => {
    try {
      const res = await mixGetV1('/api/v1/fe/customer/profile')

      if(res.status) {
        setUser(res.data)
      }
    } catch(err) {
      message.error(err?.message || 'Có lỗi xảy ra')
    }
  }
  const mixDayNext = (days:number) => {
    // Lấy ngày hiện tại
    const currentDate = new Date()

    // Lấy ngày, tháng, năm hiện tại
    const currentDay = currentDate.getDate()
    const currentMonth = currentDate.getMonth() + 1 // Tháng trong JavaScript bắt đầu từ 0
    const currentYear = currentDate.getFullYear()

    const now = `${currentDay}/${currentMonth}/${currentYear}`

    // Lấy ngày sau số ngày được truyền vào
    const futureDate = new Date()
    futureDate.setDate(currentDate.getDate() + days)

    // Lấy ngày, tháng, năm của ngày sau số ngày đó
    const futureDay = futureDate.getDate()
    const futureMonth = futureDate.getMonth() + 1
    const futureYear = futureDate.getFullYear()
    const next = `${futureDay}/${futureMonth}/${futureYear}`
    return {
      now,
      next,
    }
  }

  const mixCurrencyFormat = (val:any) => {
    return (new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val))
  }
  // const mixCurrencyFormat = (vnd: number, rate: number = 26371) => {
  //   if (!vnd) return "$0.00";

  //   const usd = vnd / rate;

  //   return new Intl.NumberFormat("en-US", {
  //     style: "currency",
  //     currency: "USD",
  //   }).format(usd);
  // };

  // useEffect
  useEffect(()=> {
    getGoiDetail(slug)
  },[slug])
  // useEffect(()=> {
  //   console.log(detail)
  // },[detail])
  useEffect(()=> {
    getUser()
  },[])

  return (
    <div className='Checkout'>
      <div
        className="App-Container local-default-background flex-container justify-content-center"
        data-testid="checkout-container"
      >
        <div className="App">
          <div
            className="App-Overview"
            style={{ backgroundColor: "rgb(255, 255, 255)" }}
          >
            <header
              className="App-header wEAIlV87__Header"
              style={{ backgroundColor: "rgb(255, 255, 255)" }}
            >
              <div className="aYuOZURb__Header-content flex-container align-items-stretch">
                <div className="flex-item width-auto flex-container align-items-center width-auto">
                  <a
                    className="Link NTVCZeIn__BusinessLink alXgr_l1__BusinessLink--withArrow Link--primary"
                    href="/payment"
                    aria-label="Quay lại StackBlitz, Inc."
                    title="StackBlitz, Inc."
                    target="_self"
                    data-testid="business-link"
                  >
                    <div style={{ position: "relative" }}>
                      <div className="flex-container align-items-center">
                        <div
                          className="l-dw6QUX__BusinessLink-backArrowContainer"
                          style={{ opacity: 1, transform: "none" }}
                        >
                          <svg
                            className="InlineSVG Icon _7GXAXK4O__BusinessLink-backArrow mr2 Icon--sm"
                            focusable="false"
                            width={12}
                            height={12}
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M3.417 7H15a1 1 0 0 1 0 2H3.417l4.591 4.591a1 1 0 0 1-1.415 1.416l-6.3-6.3a1 1 0 0 1 0-1.414l6.3-6.3A1 1 0 0 1 8.008 2.41z"
                              fillRule="evenodd"
                            />
                          </svg>
                        </div>
                        <span className="BjJO-0hk__BusinessLink-backLabel Text Text-color--gray800 Text-fontSize--14 Text-fontWeight--500">
                          Back
                        </span>
                        <div
                          className="Pd_4lI3L__BusinessLink-content"
                          style={{ transform: "none" }}
                        >
                          <div className="_83elD2bt__Business">
                            <div className="eE_Im7YT__HeaderImage--logo scD5qOnJ__Business-image flex-item width-fixed flex-container justify-content-center align-items-center width-fixed">
                              <img
                                alt="StackBlitz, Inc. logo"
                                src="https://portal.bidai.vip/magicAI-logo%20(1).svg"
                                className="j5BCE4sQ__HeaderImage-img"
                                loading="lazy"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </header>
            <div
              aria-hidden="true"
              style={{
                position: "absolute",
                top: 0,
                width: 0,
                height: 0,
                opacity: 0
              }}
            />
            <div className="OrderSummaryColumn" data-testid="order-summary-column">
              <div
                data-testid="product-summary"
                className="ProductSummary no-image is-recurring"
              >
                <div className="ProductSummary-info">
                  <h2
                    className="ProductSummary-name Text Text-color--gray500 Text-fontSize--16 Text-fontWeight--500"
                    data-testid="product-summary-name"
                  >
                    {detail?.content?.val1 || ''}
                  </h2>
                  <div className="ProductSummary-amountsContainer false">
                    <div className="ProductSummary-totalsRead" style={{ opacity: 1 }}>
                      <div className="ProductSummary-totalAmountContainer">
                        <div className="">
                          <span
                            className="ProductSummary-totalAmount Text Text-color--default Text-fontWeight--600 Text--tabularNumbers"
                            id="ProductSummary-totalAmount"
                            data-testid="product-summary-total-amount"
                          >
                            <div className="ProductSummaryTotalAmount flex-container direction-row align-items-baseline wrap-wrap">
                              <div className="mr2 flex-item width-fixed">
                                <span className="CurrencyAmount">
                                  { mixCurrencyFormat(mixVNDtoUSA(detail.price))}
                                </span>
                              </div>
                              <div className="flex-item width-fixed">
                                <span className="ProductSummaryTotalAmount-billingInterval Text Text-color--gray500 Text-fontSize--14">
                                  {detail.is_lifetime === 1 ? (
                                    <div>
                                      one-time <br className="BillingIntervalBreak" />
                                      payment
                                    </div>
                                  ) : detail.day === 30 ? (
                                    <div>
                                      every <br className="BillingIntervalBreak" />
                                      month
                                    </div>
                                  ) : (
                                    <div>
                                      every <br className="BillingIntervalBreak" />
                                      year
                                    </div>
                                  )}
                                </span>
                              </div>
                            </div>
                          </span>
                        </div>
                      </div>
                      <div className="AnimateSinglePresence">
                        <div className="AnimateSinglePresenceItem">
                          <div>
                            <div
                              className="ProductSummary-amountsDescriptions"
                              data-testid="product-summary-description"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="ProductSummary-buttonsContainer"
                    data-testid="product-summary-buttons"
                  />
                </div>
              </div>
              <section
                data-testid="order-details"
                className="OrderDetails App-Overview-OrderDetails my6"
              >
                <ul className="OrderDetails-items">
                  <li
                    className="OrderDetails-item"
                    style={{
                      opacity: 1,
                      transform: "scale(1)",
                      height: "auto",
                      marginBottom: 16
                    }}
                  >
                    <div className="LineItem flex-container align-items-flex-start">
                      <div className="flex-container justify-content-space-between align-items-baseline wrap-wrap width-grow">
                        <div className="flex-column-break" style={{ order: 2 }} />
                        <div className="flex-column-break" style={{ order: 5 }} />
                        <div
                          className="LineItem-productName flex-item width-auto"
                          data-testid="line-item-product-name"
                          style={{ order: 0 }}
                        >
                          <span className="Text Text-color--default Text-fontSize--14 Text-fontWeight--500">
                            <div className="ExpandableText">
                              <div
                                data-testid=""
                                className="ExpandableText--truncated"
                                style={{ WebkitLineClamp: 2 }}
                              >
                                {detail?.content?.val1 || ''}
                              </div>
                            </div>
                          </span>
                        </div>
                        <div
                          className="flex-container direction-column wrap-wrap"
                          style={{ width: "100%", order: 3 }}
                        >
                          <div className="flex-container direction-row wrap-wrap">
                            <div
                              className="LineItem-description flex-item width-grow"
                              style={{ order: 3 }}
                            >
                              <span className="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">
                                <span data-testid="line-item-billing-interval">
                                  {detail?.is_lifetime === 1 ? 'One-time payment' : detail?.day === 30 ? 'Monthly payment' : 'Yearly payment'}
                                </span>
                              </span>
                            </div>
                            <div
                              className="LineItem-amountDetail flex-item width-auto flex-container align-items-flex-end width-auto"
                              data-testid="line-item-amount-detail"
                              style={{ order: 4 }}
                            >
                              <div className="flex-item width-auto flex-item-align-right" />
                            </div>
                          </div>
                        </div>
                        <div
                          className="LineItem-tierBreakdown flex-item width-auto flex-item-align-left"
                          style={{ order: 6 }}
                        >
                          <div
                            className="flex-container"
                            data-testid="line-item-tiers"
                          />
                        </div>
                        <div
                          className="flex-container Placeholder"
                          style={{ opacity: 1 }}
                        >
                          <div
                            className="ml2 flex-item width-fixed"
                            data-testid="line-item-total-amount"
                            style={{ order: 1 }}
                          >
                            <span className="Text Text-color--default Text-fontSize--14 Text-fontWeight--500 Text--tabularNumbers">
                              <span className="CurrencyAmount">{ mixCurrencyFormat(mixVNDtoUSA(detail?.price))}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                    className="OrderDetails-item"
                    style={{
                      opacity: 1,
                      transform: "scale(1)",
                      height: "auto",
                      marginBottom: 16
                    }}
                  >
                    <div className="LineItem flex-container align-items-flex-start justify-content-space-between width-12">
                      <div className="flex-container justify-content-space-between align-items-baseline wrap-wrap width-12">
                        <div
                          className="LineItem-productName flex-item"
                          data-testid="line-item-product-name"
                          style={{ order: 0 }}
                        >
                          <span className="Text Text-color--default Text-fontSize--14 Text-fontWeight--500">
                            <div className="ExpandableText">
                              <div
                                data-testid=""
                                className="ExpandableText--truncated"
                                style={{ WebkitLineClamp: 2 }}
                              >
                                Plan Duration
                              </div>
                            </div>
                          </span>
                        </div>
                        <div
                          className="flex-container Placeholder"
                          style={{ opacity: 1 }}
                        >
                          <div
                            className="ml2 flex-item width-fixed"
                            data-testid="line-item-total-amount"
                            style={{ order: 1 }}
                          >
                            <span className="Text Text-color--default Text-fontSize--14 Text-fontWeight--500 Text--tabularNumbers">
                              <span className="CurrencyAmount">{ detail?.is_lifetime === 1 ? 'Lifetime' : `${ detail.day } days` }</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                    className="OrderDetails-item"
                    style={{
                      opacity: 1,
                      transform: "scale(1)",
                      height: "auto",
                      marginBottom: 16
                    }}
                  >
                    <div className="LineItem flex-container align-items-flex-start justify-content-space-between width-12">
                      <div className="flex-container justify-content-space-between align-items-baseline wrap-wrap width-12">
                        <div
                          className="LineItem-productName flex-item"
                          data-testid="line-item-product-name"
                          style={{ order: 0 }}
                        >
                          <span className="Text Text-color--default Text-fontSize--14 Text-fontWeight--500">
                            <div className="ExpandableText">
                              <div
                                data-testid=""
                                className="ExpandableText--truncated"
                                style={{ WebkitLineClamp: 2 }}
                              >
                                Plan Starts on
                              </div>
                            </div>
                          </span>
                        </div>
                        <div
                          className="flex-container Placeholder"
                          style={{ opacity: 1 }}
                        >
                          <div
                            className="ml2 flex-item width-fixed"
                            data-testid="line-item-total-amount"
                            style={{ order: 1 }}
                          >
                            <span className="Text Text-color--default Text-fontSize--14 Text-fontWeight--500 Text--tabularNumbers">
                              <span className="CurrencyAmount">{mixDayNext(detail.day).now} </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                    className="OrderDetails-item"
                    style={{
                      opacity: 1,
                      transform: "scale(1)",
                      height: "auto",
                      marginBottom: 16
                    }}
                  >
                    <div className="LineItem flex-container align-items-flex-start justify-content-space-between width-12">
                      <div className="flex-container justify-content-space-between align-items-baseline wrap-wrap width-12">
                        <div
                          className="LineItem-productName flex-item"
                          data-testid="line-item-product-name"
                          style={{ order: 0 }}
                        >
                          <span className="Text Text-color--default Text-fontSize--14 Text-fontWeight--500">
                            <div className="ExpandableText">
                              <div
                                data-testid=""
                                className="ExpandableText--truncated"
                                style={{ WebkitLineClamp: 2 }}
                              >
                                Plan Expires on
                              </div>
                            </div>
                          </span>
                        </div>
                        <div
                          className="flex-container Placeholder"
                          style={{ opacity: 1 }}
                        >
                          <div
                            className="ml2 flex-item width-fixed"
                            data-testid="line-item-total-amount"
                            style={{ order: 1 }}
                          >
                            <span className="Text Text-color--default Text-fontSize--14 Text-fontWeight--500 Text--tabularNumbers">
                              <span className="CurrencyAmount">{ detail?.is_lifetime === 1 ? 'Lifetime' : mixDayNext(detail?.day).next}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div className="OrderDetails-footer">
                  <div className="">
                    {/* <div className="YGErOEoF__Subtotal flex-container justify-content-space-between">
                      <span className="Text Text-color--default Text-fontSize--14 Text-fontWeight--500">
                        Tổng phụ
                      </span>
                      <div
                        className="flex-container Placeholder"
                        style={{ opacity: 1 }}
                      >
                        <span
                          className="Text Text-color--default Text-fontSize--14 Text-fontWeight--600 Text--tabularNumbers"
                          data-testid="order-details-footer-subtotal-amount"
                        >
                          <span className="CurrencyAmount">500,00&nbsp;US$</span>
                        </span>
                      </div>
                    </div>
                    <div className="OrderDetailsFooter-subtotalItems flex-container direction-column">
                      <div className="FadeWrapper">
                        <div className="Fade rI7PplXF__PromotionCodeAndDiscountLines _7gbzcHYI__is-notEmpty">
                          <div className="Fade-item">
                            <div className="FE01xERe__PromotionCodeEntry">
                              <div className="KqPFjWub__PromotionCodeEntry-inputWrapper p1W448QL__PromotionCodeEntry-inputWrapper--blurred">
                                <label>
                                  <div className="O60UdJa1__PromotionCodeEntry-label">
                                    <span
                                      className="Text Text-color--default"
                                      style={{ color: "rgb(0, 116, 212)" }}
                                    >
                                      Thêm mã khuyến mãi
                                    </span>
                                  </div>
                                  <div className="CheckoutInputContainer">
                                    <span className="InputContainer">
                                      <input
                                        className="CheckoutInput _Tve3O0M__PromotionCodeEntry-input Input Input--empty"
                                        autoComplete="off"
                                        autoCorrect="off"
                                        spellCheck="false"
                                        size={1}
                                        type="text"
                                        name="promotionCode"
                                        id="promotionCode"
                                        aria-label="Thêm mã khuyến mãi"
                                        placeholder="Thêm mã khuyến mãi"
                                        aria-invalid="false"
                                        data-1p-ignore="false"
                                        data-lp-ignore="false"
                                        defaultValue=""
                                      />
                                    </span>
                                  </div>
                                </label>
                                <button
                                  className="Button omtkhhcF__PromotionCodeEntry-applyButton Button--link Button--md"
                                  type="button"
                                  disabled=""
                                  aria-hidden="true"
                                >
                                  <div className="flex-container justify-content-center align-items-center">
                                    <span
                                      className="Text Text-color--default Text-fontWeight--500 Text--truncate"
                                      style={{ color: "rgb(0, 116, 212)" }}
                                    >
                                      Áp dụng
                                    </span>
                                  </div>
                                </button>
                              </div>
                              <div className="AnimateSinglePresence" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    
                    <div className="OrderDetails-total flex-container justify-content-space-between">
                      <span>
                        <span className="Text Text-color--default Text-fontSize--14 Text-fontWeight--500">
                          Total
                        </span>
                      </span>
                      <div
                        className="flex-container Placeholder"
                        style={{ opacity: 1 }}
                      >
                        <span
                          className="Text Text-color--default Text-fontSize--16 Text-fontWeight--600 Text--tabularNumbers"
                          id="OrderDetails-TotalAmount"
                        >
                          <span className="CurrencyAmount">{ mixCurrencyFormat(mixVNDtoUSA(detail?.price))}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <CheckoutPaymentForm user={user} detail={detail}/>
        </div>
      </div>
    </div>

  )
}

export default Checkout;